import React, { useEffect, useState } from 'react';
import { axiosInstance, formatDate } from '../../utils';
import { useSelector } from 'react-redux';
import edit from "../../assets/svgs/edit_pen.svg";
import { EditFeeModal } from '../../components';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Oval } from "react-loader-spinner";


const PriceManag = () => {
  const [open, setOpen] = useState(true);
  const [fee, setFee] = useState([]);
  const [priceHistory, setPriceHistory] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectAdmin, setSelectAdmin] = useState("");
  const [getAdminListData, setGetAdminListData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);

  const stateUser = useSelector((state) => state?.auth?.user);

  const handleOpen = () => {
    setOpen(!open);
  }


  const token = localStorage?.getItem("token");

  useEffect(() => {

    axiosInstance.get("/api/get-fees", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        setFee(res.data?.data);
      })
      .catch(err => console.log(err));
    getAdminList();
  }, [fee])

  useEffect(() => {
    // getPriceHistory();
    const getPriceHistory = () => {
      axiosInstance.get(`/api/price-change-history?page=${currentPage}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(res => {

          setLoading(false);
          setPriceHistory(res.data?.data?.priceChangeHistory);
        })
        .catch(err => {
          toast.error(err.response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

        });
    }
    getPriceHistory();
  }, [currentPage, priceHistory]);



  const getAdminList = () => {
    axiosInstance.get("/api/admin/get-admin-username-list", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => {
        setGetAdminListData(res?.data?.data?.usernameList);
      })
      .catch(err => {
        toast.error(err.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

      })
  }


  const handleAdminSelect = (e) => {
    setSelectAdmin(e.target.value);
  }





  const onApply = async () => {

    try {
      if (!fromDate) {
        toast.error("Please, select Start Date", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (!toDate) {
        toast.error("Please, select End Date", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {

        if (fromDate && toDate) {
          const fromDateVal = new Date(fromDate);
          const fromDateFormat = formatDate(fromDateVal)
          const toDateVal = new Date(toDate);
          const toDateFormat = formatDate(toDateVal)


          const bodyValues = {
            "fromDate": fromDateFormat,
            "toDate": toDateFormat,
            "username": selectAdmin
          };

          const response = await axiosInstance.post("/api/search-price-change-history", bodyValues, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
          const data = response.data;
          setPriceHistory(data?.data?.priceChangeHistory);
        }
      }
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

    }
  }

  const onReset = () => {
    setFromDate("");
    setToDate("");
    setSelectAdmin("");
  }


  const handleEditFee = () => {
    setEditModalOpen(true);
  }

  const handleCancelEdit = () => {
    setEditModalOpen(false);
  }

  const indexOfLastItem = 1 * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = priceHistory.slice(0, itemsPerPage);


  const onPrevious = () => {
    setCurrentPage((prev) => prev - 1);
  }

  const onNext = () => {
    setCurrentPage((prev) =>
      prev + 1
    );
  }

  const update = (result) => {
    updateFee(result);
  }

  const updateFee = async (result) => {
    if (!result.feeName) {
      toast.error("Please, Select Fee Name",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
    } else if (!result.feeValue) {
      toast.error("Please, Enter Fee Value",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
    } else if (!result.feeName && !result.feeValue) {
      toast.error("Please, Enter Values",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
    }
    else {
      try {
        const data = {
          feeName: result.feeName,
          feeValue: result.feeValue
        }
        await axiosInstance.post("/api/update-fee", data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(res => {
            toast.success("Fee Update Successfully!",
              {
                position: "top-right",
                autoClose: 5000,
                theme: "light",
                hideProgressBar: true,
              }
            );
            setEditModalOpen(false);
          })
          .catch(err => {
            toast.error(err.response.data.message,
              {
                position: "top-right",
                autoClose: 5000,
                theme: "light",
                hideProgressBar: true,
              }
            );
          })

      } catch (error) {
        toast.error(error,
          {
            position: "top-right",
            autoClose: 5000,
            theme: "light",
            hideProgressBar: true,
          }
        );
      }
    }
  }




  return (
    <section className='container py-10'>
      <div className='pb-14 grid lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 gap-4'>
        <div className=' h-[200px] rounded-md bg-white px-6 py-4 lg:w-full md:w-[400px] sm:w-[400px] w-[400px]'>
          <h2 className='heading-two pb-3'>Gold buy price for 99.99%</h2>
          <div className='pb-3'>
            <div className='flex justify-between items-center'>
              <p className='text-regular !text-secondary-n-200'>Markup Buy Price RM</p>
              <input type='number' min={0} className='rounded-md w-20 h-7 border-[1px] outline-none px-3 border-secondaey-n-40 text-secondary-n-90' />
            </div>
          </div>
          <div className='pb-5'>
            <div className='flex justify-between items-center'>
              <p className='text-regular !text-secondary-n-200'>Markup Sell Price RM</p>
              <input type='number' min={0} className='rounded-md w-20 h-7 border-[1px] outline-none px-3 border-secondaey-n-40 text-secondary-n-90' />
            </div>
          </div>
          <div className='flex justify-end'>
            <button className='flex justify-center items-center bg-primary-yellow-500 w-20 h-8 rounded-md text-white'>Save</button>
          </div>
        </div>
        <div className=' h-[200px] rounded-md bg-white px-6 py-4 lg:w-full md:w-[400px] sm:w-[400px] w-[400px]'>
          <h2 className='heading-two pb-3'>Tax Charges</h2>
          <div className='pb-3'>
            <div className='flex justify-between items-center'>
              <p className='text-regular !text-secondary-n-200'>SST Charges (%)</p>
              <input type='number' min={0} className='rounded-md w-20 h-7 border-[1px] outline-none px-3 border-secondaey-n-40 text-secondary-n-90' />
            </div>
          </div>
          <div className='pb-5'>
            <div className='flex justify-between items-center'>
              <p className='text-regular !text-secondary-n-200'>Processing Charges (%)</p>
              <input type='number' min={0} className='rounded-md w-20 h-7 border-[1px] outline-none px-3 border-secondaey-n-40 text-secondary-n-90' />
            </div>
          </div>
          <div className='flex justify-end'>
            <button className='flex justify-center items-center bg-primary-yellow-500 w-20 h-8 rounded-md text-white'>Save</button>
          </div>
        </div>
        <div className=' h-[200px] rounded-md bg-white px-6 py-4 lg:w-full md:w-[400px] sm:w-[400px] w-[400px]'>
          <h2 className='heading-two pb-3'>Delivery Charges</h2>
          <div className='pb-12'>
            <div className='flex justify-between items-center'>
              <p className='text-regular !text-secondary-n-200'>Delivery Charges RM</p>
              <input type='number' min={0} className='rounded-md w-20 h-7 border-[1px] outline-none px-3 border-secondaey-n-40 text-secondary-n-90' />
            </div>
          </div>

          <div className='flex justify-end'>
            <button className='flex justify-center items-center bg-primary-yellow-500 w-20 h-8 rounded-md text-white'>Save</button>
          </div>
        </div>
      </div>
      <h1 className='heading-one !text-secondary-n-400 !pb-3'>Price change history</h1>
      <div className={`bg-white lg:w-full md:w-[450px] sm:w-[450px] w-[400px] min-h-24 px-6 py-3 rounded-md  mb-6 border-t-8 border-t-primary-yellow-500`}>
        {/* <div className='flex justify-start items-center pb-4'>
                <div className='flex items-center gap-3'>
                    <div className='relative'>
                        <input type='text' className='lg:w-[320px] sm:w-[320px] md:w-[320px] w-[250px] border-[1px] border-secondary-n-40 p-3 rounded-md outline-none' placeholder='Search' />
                        <div className='absolute right-0 top-0 rounded-md h-[49px] w-12 flex justify-center items-center bg-primary-yellow-500'>
                      <img src={search} alt='search' />

                        </div>
                    </div>
                    <button className='flex justify-center items-center rounded-md w-12 h-12 bg-primary-yellow-500' onClick={handleOpen}>   
                    <img src={filter} alt="filter" />
                    </button>
                </div>
        
                
            </div> */}

        <div className={``}>
          <div className='flex flex-col gap-3'>
            <div className='flex items-center gap-3 lg:flex-row md:flex-col sm:flex-col flex-col'>
              <div className='flex flex-col gap-1'>
                <label className='text-sm'>From date</label>
                <input type='date' className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholder='dd/mm/yyyy' value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                {/* <DatePicker className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholderText='select date' selected={fromDate} onChange={(date) => setFromDate(date)} dateFormat={"dd-MM-yyyy"} /> */}

              </div>
              <div className='flex flex-col gap-1'>
                <label className='text-sm'>To date</label>
                <input type='date' className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholder='dd/mm/yyyy' value={toDate} onChange={(e) => setToDate(e.target.value)} />
                {/* <DatePicker className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholderText='select date' selected={toDate} onChange={(date) => setToDate(date)} dateFormat={"dd-MM-yyyy"} /> */}

              </div>
              <div className='flex flex-col gap-1'>
                <label className='text-sm'>User Name</label>
                <select className='w-[290px] border-[1px] border-secondary-n-40 p-[14px] text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' value={selectAdmin} onChange={handleAdminSelect}>
                  <option value={""} selected>Select user type</option>
                  {loading ? (
                    <option>loading ...</option>
                  ) : (
                    <>

                      {getAdminListData?.map((data, index) => {
                        return (
                          <option key={index}>{data}</option>
                        )
                      })}
                    </>
                  )}
                </select>
              </div>
            </div>
            <div className='flex lg:justify-end md:justify-center sm:justify-center justify-center'>
              <div className='flex items-center gap-3'>
                <button className='p-2 border-[1px] border-primary-yellow-500 bg-transparent text-primary-yellow-500 font-poppins text-sm font-medium rounded-md w-28' onClick={onReset}>Reset</button>
                <button className='p-2 bg-primary-yellow-500  text-white font-poppins text-sm font-medium rounded-md w-28' onClick={onApply}>Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='bg-white min-h-[100px] rounded-md space-y-3 mb-6'>
        <div className=" w-full  rounded-md overflow-x-scroll mb-7">
          <table className="">
            <thead className="border-b-2 border-b-secondary-n-40">
              <tr>
                <th className="p-4">No</th>
                <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Updates by (Username)</th>
                <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">Updates by (email)</th>
                <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">Date</th>
                <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Time</th>
                <th className="p-4 border-l-2 border-dashed border-x-secondary-n-40">Updated Details</th>
                <th className="p-4 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Old Price</th>
                <th className="p-4 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Updated Price</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length === 0 ? (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className='whitespace-nowrap text-base font-poppins font-medium flex  items-center text-center'>No Data</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                <>
                  {currentItems?.map((result, index) => {
                    const date = new Date(result.timeStamp);
                    const localDate = date.toLocaleDateString();
                    const localTime = date.toLocaleTimeString();
                    return (
                      <tr key={index}>
                        <td className='text-center p-4'>{index + 1}</td>
                        <td className='text-center border-l-2 border-dashed px-6'>{result?.username}</td>
                        <td className='text-center border-l-2 border-dashed px-6'>{result?.email}</td>
                        <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{localDate}</td>
                        <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{localTime}</td>
                        <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>

                          <p>{result?.feeName}</p>


                        </td>
                        <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>

                          <p>{result?.oldPrice} RM</p>


                        </td>
                        <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>

                          <p>{result?.updatedPrice} RM</p>


                        </td>

                      </tr>
                    )
                  })}
                </>
              )}
              {/* Add more rows as needed */}
            </tbody>
          </table>
        </div>

        <div className='flex justify-end items-center pb-3 space-x-4 container'>
          <button
            onClick={onPrevious}
            disabled={currentPage === 0}
            className={`p-2 font-poppins text-sm font-medium rounded-md w-28 ${currentPage === 0 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-primary-yellow-500 text-white'}`}
          >
            Previous
          </button>
          <button onClick={onNext}
            disabled={indexOfLastItem > priceHistory.length}
            className={`p-2 ${indexOfLastItem > priceHistory.length ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-primary-yellow-500 text-white'} font-poppins text-sm font-medium rounded-md w-28`}


          >
            Next
          </button>
        </div>
      </div>

      {stateUser?.auth === "ROLE_ADMIN" ? (
        <>
          <h1 className='heading-one !text-secondary-n-400 !pb-3'>Fees</h1>
          <div className="bg-white w-full min-h-[100px] rounded-md overflow-x-scroll mb-7">
            <table className="">
              <thead className="border-b-2 border-b-secondary-n-40">
                <tr>
                  <th className="p-4">No</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Buy Service Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">SST Tax Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Storage Insurance Charges Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Sell Service Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Send Gold  Service Fee</th>
                  <th className="p-4 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Redeem Pickup Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">
                    Redeem Delivery Fee
                  </th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Redeem Delivery Service Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">Redeem Pickup Service Fee</th>
                  <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  loading ? (
                    <tr className=''>
                      <td className='font-poppins font-medium text-base  pl-72 flex items-center gap-5' colSpan={"10"}>

                        <Oval
                          height={20}
                          width={20}
                          color="#666666"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel='oval-loading'
                          secondaryColor="#757575"
                          strokeWidth={2}
                          strokeWidthSecondary={2}

                        />
                        Loading....
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td className='text-center p-4'>{1}</td>
                      <td className='text-center border-l-2 border-dashed px-6'>{fee?.buyServiceFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6'>{fee?.sstTaxFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{fee?.storageInsuranceChargesFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6'>{fee?.sellServiceFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{fee?.sendGoldServiceFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{fee?.redeemPickupDeliveryFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{fee?.redeemDeliveryDeliveryFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{fee?.redeemDeliveryServiceFee} RM</td>
                      <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{fee?.redeemPickupServiceFee} RM</td>
                      <td className='border-l-2 border-dashed px-6'>
                        <div className='flex items-center gap-1'>
                          {/* <img src={eye} alt='eye' /> */}
                          <img src={edit} alt='edit' onClick={handleEditFee} />
                        </div>
                      </td>
                    </tr>
                  )
                }

              </tbody>
            </table>
          </div>
        </>

      ) : (
        <></>
      )}
      {editModalOpen && <EditFeeModal cancel={handleCancelEdit} update={update} />}
      <ToastContainer />
    </section>
  )
}

export default PriceManag;